"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateOfBirthInputError = exports.SETTINGS = exports.ERRORS = void 0;
/**
 * @deprecated Use `Ds.Form` instead
 */
exports.ERRORS = {
    MISSING_VALUES: "Enter a date of birth",
    INVALID_FORMAT: "Enter a date of birth in the format DD MM YYYY, e.g. 31 12 1970",
    INVALID_CHARACTERS: "Enter a date of birth using numbers only",
    YEAR_BEFORE_1900: "A date of birth cannot be before 1900. Enter a date of birth in the format DD MM YYYY, e.g. 31 12 1970",
    FUTURE_BIRTH_DATE: "A date of birth cannot be in the future",
};
exports.SETTINGS = {
    EARLIEST_YEAR: 1900,
};
const REGEX_ONLY_NUMBERS = /^[0-9]+$/;
/**
 * @deprecated Use `Ds.Form` instead
 */
function getDateOfBirthInputError({ day, month, year, }) {
    if (!day || !month || !year) {
        return exports.ERRORS.MISSING_VALUES;
    }
    if (day.length > 2 || month.length > 2 || year.length > 4) {
        return exports.ERRORS.INVALID_FORMAT;
    }
    const numberedDate = {
        day: parseInt(day),
        month: parseInt(month),
        year: parseInt(year),
    };
    if (!REGEX_ONLY_NUMBERS.test(day) ||
        !REGEX_ONLY_NUMBERS.test(month) ||
        !REGEX_ONLY_NUMBERS.test(year)) {
        return exports.ERRORS.INVALID_CHARACTERS;
    }
    return getDateOfBirthValueError(numberedDate);
}
exports.getDateOfBirthInputError = getDateOfBirthInputError;
function getDateOfBirthValueError({ day, month, year, }) {
    if (isValueCalendarValid({ day, month, year })) {
        return exports.ERRORS.INVALID_FORMAT;
    }
    /** If date is in the future, show the error - without using a third party library */
    const todaysDate = new Date();
    const [todaysDay, todaysMonth, todaysYear] = [
        todaysDate.getUTCDate(),
        todaysDate.getUTCMonth() + 1, // getUTCMonth returns 0 to 11
        todaysDate.getUTCFullYear(),
    ];
    const isFutureYear = year > todaysYear;
    const isCurrentYearButFutureMonth = year === todaysYear && month > todaysMonth;
    const isCurrentYearAndMonthButFutureDay = year === todaysYear && month === todaysMonth && day > todaysDay;
    if (isFutureYear ||
        isCurrentYearButFutureMonth ||
        isCurrentYearAndMonthButFutureDay) {
        return exports.ERRORS.FUTURE_BIRTH_DATE;
    }
    if (year < exports.SETTINGS.EARLIEST_YEAR) {
        return exports.ERRORS.YEAR_BEFORE_1900;
    }
    return null;
}
/**
 * Returns the number of days in the month
 * @param m month is 1-12
 * @param y full year e.g. 1972
 */
function daysInMonth(month, year) {
    switch (month) {
        case 2: // Februrary leap year calculations
            return (year % 4 == 0 && year % 100) || year % 400 == 0 ? 29 : 28;
        case 4: // April
        case 6: // June
        case 9: // September
        case 11: // November
            return 30;
        default:
            return 31;
    }
}
/**
 * @returns boolean of whether the date provided is calendar-valid
 */
function isValueCalendarValid({ day, month, year, }) {
    return (day < 1 ||
        day > daysInMonth(month, year) ||
        month < 1 ||
        month > 12 ||
        year < 1 ||
        year > 9999);
}
//# sourceMappingURL=error.js.map